import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";
import {Schema} from "@/common/Schema";
import {PlinkoPhysicsConfig} from "@/modules/redactor/models/smart-offer/bundle-plinko/PlinkoPhysicConfig";
import {CurrencyKindModel} from "@/modules/redactor/models/currency/CurrencyKindModel";


export class PlinkoBallConfig extends Cloneable {

    static schema() {
        return custom((v) => {
            return v && !v.empty() ? serialize(PlinkoBallConfig, v) : SKIP;
        }, (v) => {
            return deserialize(PlinkoBallConfig, v);
        });
    }

    constructor() {
        super();
        this._key = null;
        this._currency = null;
        this._physicsConfig = null;
    }

    get key() {
        return this._key;
    }

    set key(value) {
        this._key = value;
    }

    get currency() {
        return this._currency;
    }

    set currency(value) {
        this._currency = value;
    }

    get physicsConfig() {
        return this._physicsConfig;
    }

    set physicsConfig(value) {
        this._physicsConfig = value;
    }

    valid() {
        if (!this.key || this.key.length === 0) {
            return false;
        }

        if (!CurrencyKindModel.is(this.currency)) {
            return false;
        }

        if (this.physicsConfig && !this.physicsConfig.valid()) {
            return false;
        }

        return true;
    }

    empty() {
        return false;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new PlinkoBallConfig());
        } else if (target instanceof PlinkoBallConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(PlinkoBallConfig, {
    _key: alias("key", Schema.primitive()),
    _currency: alias("currency", CurrencyKindModel.schema()),
    _physicsConfig: alias("physics_config", PlinkoPhysicsConfig.schema())
});